export default {
    
    find:   { method: 'get',    url: 'faq_categories' },
    create: { method: 'post',   url: 'faq_categories'},
    update: { method: 'put',    url: 'faq_categories/{id}'},
    delete: { method: 'delete', url: 'faq_categories/{id}'}
}